import React, { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import Clear from 'material-ui/svg-icons/content/clear'
import TextField from 'material-ui/TextField'
import Toggle from 'material-ui/Toggle'
import IconButton from 'material-ui/IconButton'
import { FormattedMessage } from 'react-intl'
import { ALertHeaderText } from './SeminarActions/styles'
import { getToken } from '../../lib'

const toggleStyle = {
  thumbSwitched: {
    backgroundColor: '#88E0A8'
  },
  thumbOff: {
    backgroundColor: '#46CE90'
  }
}

export default class CreateNewSeminarForm extends Component {
  state = {
    record: false,
    mobile: true,
    seminarName: '',
    nameError: false
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const {seminarName, record, mobile} = this.state
    const token = getToken()
    if (seminarName.length === 0) {
      return this.setState({nameError: true})
    }
    this.props.createConference(token, seminarName, record, mobile)
    this.props.handleClose()
  }

  handleToggle = (e, isToggled) => this.setState({record: isToggled})

  handleToggleMobile = (e, isToggled) => this.setState({mobile: !isToggled})

  handleChange = (e) => this.setState({seminarName: e.target.value, nameError: false})

  render () {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className='flex justify-between items-center'>
          <ALertHeaderText>
            <FormattedMessage id='seminar.createNew'/>
          </ALertHeaderText>
          <div>
            <IconButton onTouchTap={this.props.handleClose} iconStyle={{fill: '#afb8c5'}}>
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div>
          <div className='mb4'>
            <TextField
              errorText={(this.state.nameError) ? 'This field is required' : null}
              hintText='Anet Seminar'
              floatingLabelText={<FormattedMessage id='seminar.seminarName'/>}
              fullWidth
              onChange={this.handleChange}
              value={this.state.seminarName}
            />
          </div>
          <div className='flex justify-between items-center mb4'>
            <div>{<FormattedMessage id='seminar.record'/>}</div>
            <div>
              <Toggle
                label={(this.state.record) ? (
                  <FormattedMessage id='seminar.on'/>
                ) : <FormattedMessage id='seminar.off'/>}
                toggled={this.state.record}
                onToggle={this.handleToggle}
                labelPosition='left'
                thumbSwitchedStyle={toggleStyle.thumbOff}
                trackSwitchedStyle={toggleStyle.thumbSwitched}
                labelStyle={{
                  fontSize: '14px',
                  lineHeight: '20px',
                  color: 'rgba(107, 124, 147, 1)',
                  opacity: 1,
                  width: 'calc(100% - 44px)'
                }}
                ref='remember'/>
            </div>
          </div>
          <div className='flex justify-between items-center mb4'>
            <div>{<FormattedMessage id='seminar.mobile'/>}</div>
            <div>
              <Toggle
                label={(!this.state.mobile) ? (
                  <FormattedMessage id='seminar.on'/>
                ) : <FormattedMessage id='seminar.off'/>}
                toggled={!this.state.mobile}
                onToggle={this.handleToggleMobile}
                labelPosition='left'
                thumbSwitchedStyle={toggleStyle.thumbOff}
                trackSwitchedStyle={toggleStyle.thumbSwitched}
                labelStyle={{
                  fontSize: '14px',
                  lineHeight: '20px',
                  color: 'rgba(107, 124, 147, 1)',
                  opacity: 1,
                  width: 'calc(100% - 44px)'
                }}
                ref='remember'/>
            </div>
          </div>
          <div className='flex justify-end'>
            <FlatButton
              label={<FormattedMessage id='loggedInNavigation.cancel'/>}
              onTouchTap={this.props.handleClose}/>
            <RaisedButton
              className='ml3'
              backgroundColor='#FCCE42'
              type='submit'
              label={<FormattedMessage id='seminar.create'/>}/>
          </div>
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Seminars/CreateNewSeminarForm.js